.trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  text-align: left;
  cursor: pointer;
}

.trigger[data-placeholder] {
  color: var(--color-fg-subtle);
}

.chevron {
  display: inline-flex;
  color: var(--color-fg-muted);
}

.chevron svg {
  width: var(--size-icon);
  height: var(--size-icon);
}

.content {
  max-height: var(--radix-select-content-available-height);
  min-width: var(--radix-select-trigger-width);
  overflow: hidden;
  /* The list scrolls and a footer stays in view below it. */
  display: flex;
  flex-direction: column;
}

.content > [data-radix-select-viewport] {
  flex: 1 1 auto;
  min-height: 0;
}

.groupLabel {
  padding: var(--space-2) var(--space-2) var(--space-1) var(--space-8);
  color: var(--color-fg-muted);
  font-size: var(--text-2xs);
  font-weight: var(--weight-semibold);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.description {
  margin-left: auto;
  padding-left: var(--space-4);
  color: var(--color-fg-muted);
  font-size: var(--text-xs);
}

/* A colour swatch before an option's label (a layer's colour), bordered so white and pale colours read. */
.swatch {
  display: inline-block;
  flex-shrink: 0;
  width: var(--space-3);
  height: var(--space-3);
  margin-right: var(--space-1-5);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-xs);
  vertical-align: -0.125em;
}

/* A drawing before an option's label (a linetype's pattern). */
.preview {
  display: inline-flex;
  margin-right: var(--space-2);
  vertical-align: middle;
}

.separator {
  height: 1px;
  margin: var(--space-1) 0;
  background: var(--color-border);
}

/* The trigger's value keeps a drawing and its label on one line. */
.trigger > span:first-child {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

/* In the closed control the name comes first: a narrow trigger clips the drawing's strip, never scales it. */
.trigger .preview {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 45%;
  overflow: hidden;
}

/* An option that leaves the list for somewhere else: the accent colour is for what can be acted on. */
.action {
  /* Always in view at the foot of a long list, as the last entry. */
  position: sticky;
  bottom: calc(-1 * var(--space-1));
  margin-top: var(--space-1);
  background: var(--color-surface-raised);
  border-radius: 0 0 var(--radius-sm) var(--radius-sm);
  box-shadow: 0 -1px 0 var(--color-border);
  color: var(--color-accent-text);
  font-weight: var(--weight-medium);
}

/* Help at the foot of the list, quiet: nothing to click. */
.footer {
  margin: 0;
  padding: var(--space-2) var(--space-3);
  border-top: 1px solid var(--color-border);
  color: var(--color-fg-muted);
  font-size: var(--text-xs);
}
